export const dropdownGroups = [
    { key: 'roles', name: 'User Roles', description: 'Roles assignable from the admin panel.' },
    { key: 'single_tenancy_categories', name: 'Single Tenancy Categories', description: 'Categories used in single tenancy request and admin assignment flows.' },
    { key: 'multi_tenancy_categories', name: 'Multi Tenancy Categories', description: 'Categories used in multi tenancy request and approval flows.' },
    { key: 'azure_tenants', name: 'Azure Tenants', description: 'Tenant choices shown on VM request forms.' },
    { key: 'single_tenancy_locations', name: 'Single Tenancy Locations', description: 'Azure regions shown on the single tenancy request form.' },
    { key: 'multi_tenancy_locations', name: 'Multi Tenancy Locations', description: 'Azure regions shown on the multi tenancy request form.' },
    { key: 'single_tenancy_storage_destinations', name: 'Single Tenancy Storage Destinations', description: 'Storage destination choices shown on the single tenancy request form.' },
    { key: 'multi_tenancy_storage_destinations', name: 'Multi Tenancy Storage Destinations', description: 'Storage destination choices shown on the multi tenancy request form.' },
    { key: 'hosting_types', name: 'Hosting Types', description: 'Hosting setup choices shown on request forms.' },
    {
        key: 'license_products',
        name: 'License Products',
        description: 'Products, add-ons, and sub-addons for License Generator. Configure API mapping in Metadata JSON (apiCategory, selectionMode, addons).'
    },
    {
        key: 'agent_operating_systems',
        name: 'Agent Operating Systems',
        description: 'Operating system choices shown on Custom Agent Creation. Disable an option to hide it from the form.'
    },
    {
        key: 'agent_backup_types',
        name: 'Agent Backup Types',
        description: 'Backup type choices shown on Custom Agent Creation. Use metadata.disallowedOperatingSystems (e.g. ["Mac"]) to hide an option for specific OS values. Disable an option to hide it entirely.'
    },
    {
        key: 'agent_environments',
        name: 'Agent PODs',
        description: 'POD choices shown on Custom Agent Creation. Values must match the agent workflow environment options. Disable an option to hide it from the form.'
    }
];

export const dropdownDefaults = {
    roles: [
        { key: 'ST_FORM_FILLER', text: 'ST Form Filler', value: 'ST_FORM_FILLER' },
        { key: 'MT_FORM_FILLER', text: 'MT Form Filler', value: 'MT_FORM_FILLER' },
        { key: 'MT_DECOMMISSION_REQUESTER', text: 'MT Decommission Requester', value: 'MT_DECOMMISSION_REQUESTER' },
        { key: 'MT_DECOMMISSION_APPROVER', text: 'MT Decommission Approver', value: 'MT_DECOMMISSION_APPROVER' },
        { key: 'MT_DECOMMISSION_FINAL_APPROVER', text: 'MT Decommission Final Approver', value: 'MT_DECOMMISSION_FINAL_APPROVER' },
        { key: 'APPROVER', text: 'Approver', value: 'APPROVER' },
        { key: 'DEVOPS', text: 'DevOps', value: 'DEVOPS' },
        { key: 'LICENSE_GENERATOR', text: 'License Generator', value: 'LICENSE_GENERATOR' },
        { key: 'CAPACITY_READER', text: 'Capacity Reader', value: 'CAPACITY_READER' },
        { key: 'AGENT_CREATION', text: 'Agent Creation', value: 'AGENT_CREATION' }
    ],
    single_tenancy_categories: ['CUST', 'STAGE', 'POC', 'ENGG_DEV', 'ENGG_QA', 'DEVOPS', 'PROD', 'DEMO', 'TESTING'].map(value => ({
        key: value,
        text: value,
        value
    })),
    multi_tenancy_categories: [
        { key: 'ENGG_DEV', text: 'ENGG_DEV', value: 'ENGG_DEV' },
        { key: 'ENGG_QA', text: 'ENGG_QA', value: 'ENGG_QA' },
        { key: 'STAGE', text: 'STAGE', value: 'STAGE' },
        { key: 'PROD', text: 'PROD / POC', value: 'PROD' }
    ],
    azure_tenants: [
        {
            key: 'parablu',
            text: '*.parablu.com',
            value: '1',
            actual: '*.parablu.com',
            azureTenantId: process.env.REACT_APP_PARABLU_TENANT_ID,
            subscriptionId: process.env.REACT_APP_MACC_SUBSCRIPTION_ID,
            azureClientId: process.env.REACT_APP_PARABLU_CLIENT_ID
        },
        {
            key: 'poc',
            text: 'poc.crashplan.com',
            value: '2',
            actual: 'poc.crashplan.com',
            azureTenantId: process.env.REACT_APP_POC_TENANT_ID,
            subscriptionId: process.env.REACT_APP_CPG_POC_SUBSCRIPTION_ID,
            azureClientId: process.env.REACT_APP_CPG_POC_CLIENT_ID
        },
        {
            key: 'demo',
            text: 'demo.crashplan.com',
            value: '3',
            actual: 'demo.crashplan.com',
            azureTenantId: process.env.REACT_APP_DEMO_TENANT_ID,
            subscriptionId: process.env.REACT_APP_CPG_DEMO_SUBSCRIPTION_ID,
            azureClientId: process.env.REACT_APP_CPG_DEMO_CLIENT_ID
        },
        {
            key: 'crashplan',
            text: '*.crashplan.com',
            value: '4',
            actual: '*.crashplan.com',
            azureTenantId: process.env.REACT_APP_PARABLU_TENANT_ID,
            subscriptionId: process.env.REACT_APP_MACC_SUBSCRIPTION_ID,
            azureClientId: process.env.REACT_APP_PARABLU_CLIENT_ID
        }
    ],
    single_tenancy_locations: [
        {
            key: 'central_india',
            text: 'Central India',
            value: '1',
            urlPrefix: 'portal-in',
            details: {
                location: process.env.REACT_APP_CI_LOCATION,
                resourceGroupName: process.env.REACT_APP_CI_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_CI_VNET_NAME,
                subnetName: process.env.REACT_APP_CI_SUBNET_NAME,
                nsgName: process.env.REACT_APP_CI_NSG_NAME
            }
        },
        {
            key: 'east_us',
            text: 'East US',
            value: '2',
            urlPrefix: 'portal-use',
            details: {
                location: process.env.REACT_APP_EUS_LOCATION,
                resourceGroupName: process.env.REACT_APP_EUS_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_EUS_VNET_NAME,
                subnetName: process.env.REACT_APP_EUS_SUBNET_NAME,
                nsgName: process.env.REACT_APP_EUS_NSG_NAME
            }
        },
        {
            key: 'west_us3',
            text: 'West US3',
            value: '3',
            urlPrefix: 'portal-usw',
            details: {
                location: process.env.REACT_APP_WUS3_LOCATION,
                resourceGroupName: process.env.REACT_APP_WUS3_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_WUS3_VNET_NAME,
                subnetName: process.env.REACT_APP_WUS3_SUBNET_NAME,
                nsgName: process.env.REACT_APP_WUS3_NSG_NAME
            }
        },
        {
            key: 'uae_north',
            text: 'UAE North',
            value: '4',
            urlPrefix: 'portal-me',
            details: {
                location: process.env.REACT_APP_UAE_LOCATION,
                resourceGroupName: process.env.REACT_APP_UAE_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_UAE_VNET_NAME,
                subnetName: process.env.REACT_APP_UAE_SUBNET_NAME,
                nsgName: process.env.REACT_APP_UAE_NSG_NAME
            }
        },
        {
            key: 'west_us',
            text: 'West US',
            value: '5',
            urlPrefix: 'portal-usw',
            details: {
                location: process.env.REACT_APP_WUS_LOCATION,
                resourceGroupName: process.env.REACT_APP_WUS_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_WUS_VNET_NAME,
                subnetName: process.env.REACT_APP_WUS_SUBNET_NAME,
                nsgName: process.env.REACT_APP_WUS_NSG_NAME
            }
        },
        {
            key: 'south_east_asia',
            text: 'South East Asia',
            value: '6',
            urlPrefix: 'portal-sea',
            details: {
                location: process.env.REACT_APP_SEA_LOCATION,
                resourceGroupName: process.env.REACT_APP_SEA_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_SEA_VNET_NAME,
                subnetName: process.env.REACT_APP_SEA_SUBNET_NAME,
                nsgName: process.env.REACT_APP_SEA_NSG_NAME
            }
        },
        {
            key: 'germany_west_central',
            text: 'Germany West Central',
            value: '7',
            urlPrefix: 'portal-ffm',
            categories: ['PROD'],
            tenants: ['4'],
            details: {
                location: process.env.REACT_APP_GERMANY_LOCATION || 'GermanyWestCentral',
                resourceGroupName: process.env.REACT_APP_GERMANY_RESOURCE_GROUP_NAME || 'CUST_Frankfurt',
                vnetName: process.env.REACT_APP_GERMANY_VNET_NAME || 'cust-rewrite-frankfurt-vnet',
                subnetName: process.env.REACT_APP_GERMANY_SUBNET_NAME || 'default',
                nsgName: process.env.REACT_APP_GERMANY_NSG_NAME || 'cust-rewrite-frankfurt-nsg'
            }
        },
        {
            key: 'canada_central',
            text: 'Canada Central',
            value: '8',
            urlPrefix: 'portal-cac',
            details: {
                location: process.env.REACT_APP_CANADA_LOCATION || 'CanadaCentral',
                resourceGroupName: process.env.REACT_APP_CANADA_RESOURCE_GROUP_NAME || 'CUST_CanadaCentral',
                vnetName: process.env.REACT_APP_CANADA_VNET_NAME || 'cust-canada-central-vnet',
                subnetName: process.env.REACT_APP_CANADA_SUBNET_NAME || 'default',
                nsgName: process.env.REACT_APP_CANADA_NSG_NAME || 'cust-cac-mt-nsg-001'
            }
        }
    ],
    multi_tenancy_locations: [
        {
            key: 'central_india',
            text: 'Central India',
            value: '1',
            urlPrefix: 'prod-portal-in',
            details: {
                location: process.env.REACT_APP_CI_LOCATION,
                resourceGroupName: process.env.REACT_APP_CI_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_CI_VNET_NAME,
                subnetName: process.env.REACT_APP_CI_SUBNET_NAME,
                nsgName: process.env.REACT_APP_CI_NSG_NAME
            }
        },
        {
            key: 'east_us',
            text: 'East US',
            value: '2',
            urlPrefix: 'prod-portal-use',
            details: {
                location: process.env.REACT_APP_EUS_LOCATION,
                resourceGroupName: process.env.REACT_APP_EUS_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_EUS_VNET_NAME,
                subnetName: process.env.REACT_APP_EUS_SUBNET_NAME,
                nsgName: process.env.REACT_APP_EUS_NSG_NAME
            }
        },
        {
            key: 'uae_north',
            text: 'UAE North',
            value: '4',
            urlPrefix: 'prod-portal-uae',
            details: {
                location: process.env.REACT_APP_UAE_LOCATION,
                resourceGroupName: process.env.REACT_APP_UAE_RESOURCE_GROUP_NAME,
                vnetName: process.env.REACT_APP_UAE_VNET_NAME,
                subnetName: process.env.REACT_APP_UAE_SUBNET_NAME,
                nsgName: process.env.REACT_APP_UAE_NSG_NAME
            }
        },
        {
            key: 'germany_west_central',
            text: 'Germany West Central',
            value: '7',
            urlPrefix: 'prod-portal-ffm',
            details: {
                location: process.env.REACT_APP_GERMANY_LOCATION || 'GermanyWestCentral',
                resourceGroupName: process.env.REACT_APP_GERMANY_RESOURCE_GROUP_NAME || 'CUST_Frankfurt',
                vnetName: process.env.REACT_APP_GERMANY_VNET_NAME || 'cust-rewrite-frankfurt-vnet',
                subnetName: process.env.REACT_APP_GERMANY_SUBNET_NAME || 'default',
                nsgName: process.env.REACT_APP_GERMANY_NSG_NAME || 'cust-rewrite-frankfurt-nsg'
            }
        },
        {
            key: 'canada_central',
            text: 'Canada Central',
            value: '8',
            urlPrefix: 'prod-portal-cac',
            details: {
                location: process.env.REACT_APP_CANADA_LOCATION || 'CanadaCentral',
                resourceGroupName: process.env.REACT_APP_CANADA_RESOURCE_GROUP_NAME || 'CUST_CanadaCentral',
                vnetName: process.env.REACT_APP_CANADA_VNET_NAME || 'cust-canada-central-vnet',
                subnetName: process.env.REACT_APP_CANADA_SUBNET_NAME || 'default',
                nsgName: process.env.REACT_APP_CANADA_NSG_NAME || 'cust-cac-mt-nsg-001'
            }
        }
    ],
    single_tenancy_storage_destinations: [
        { key: 'od4b', text: 'OneDrive for Business (OD4B) [Azure and Linode]', value: '1', actual: 'OD4B', azureBlobHosted: false },
        { key: 'azure_blob_crashplan', text: 'Azure Blob - CrashPlan [Azure]', value: '2', actual: 'Azure_Blob', azureBlobHosted: true },
        { key: 'azure_blob_customer', text: 'Azure Blob - Customer [Azure]', value: '3', actual: 'Azure_Blob', azureBlobHosted: false },
        { key: 'google_drive', text: 'Google Drive [Azure and Linode]', value: '4', actual: 'Google_Drive', azureBlobHosted: false },
        { key: 'others_storage', text: 'Others (AWS / Local Storage / S3-Compatible) [Azure and Linode]', value: '5', actual: 'Others_Storage', azureBlobHosted: false }
    ],
    multi_tenancy_storage_destinations: [
        { key: 'azure_blob', text: 'Azure Blob', value: '1', actual: 'Azure_Blob', azureBlobHosted: true },
        { key: 'cpg_datacenter', text: 'CPG DataCenter', value: '2', actual: 'cpg_datacenter', azureBlobHosted: false },
        { key: 'byos', text: 'BYOS (S3-Compatible)', value: '3', actual: 'BYOS', azureBlobHosted: false }
    ],
    hosting_types: [
        { key: 'singletenant', text: 'Single Tenant Setup', value: false },
        { key: 'multitenancy', text: 'Mixed Pod Setup', value: true }
    ],
    license_products: [
        {
            key: 'microsoft_entra',
            text: 'Microsoft Entra',
            value: 'Microsoft Entra',
            // Keep provisioning payload under m365Enterprise (same as when Entra was an M365 add-on).
            apiCategory: 'm365Enterprise',
            selectionMode: 'productQuantity',
            apiProductName: 'microsoftEntra',
            addons: []
        },
        {
            key: 'm365_enterprise',
            text: 'M365 Enterprise',
            value: 'M365 Enterprise',
            apiCategory: 'm365Enterprise',
            selectionMode: 'perAddon',
            addons: [
                {
                    name: 'OneDrive',
                    apiProductName: 'oneDrive',
                    subaddons: [
                        { name: 'Capacity Savings', apiKey: 'capacitySavings' },
                        { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
                    ]
                },
                {
                    name: 'Exchange',
                    apiProductName: 'exchange',
                    subaddons: [
                        { name: 'Capacity Savings', apiKey: 'capacitySavings' },
                        { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' },
                        { name: 'In-Place Archive', apiKey: 'inplaceArchive' }
                    ]
                },
                {
                    name: 'SharePoint',
                    apiProductName: 'sharePoint',
                    subaddons: [
                        { name: 'Capacity Savings', apiKey: 'capacitySavings' },
                        { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
                    ]
                }
            ]
        },
        {
            key: 'google_workspace',
            text: 'Google Workspace',
            value: 'Google Workspace',
            apiCategory: 'googleWorkspace',
            selectionMode: 'perAddon',
            addons: [
                {
                    name: 'Gmail',
                    apiProductName: 'gmail',
                    subaddons: [
                        { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
                    ]
                },
                {
                    name: 'Gdrive',
                    apiProductName: 'gDrive',
                    subaddons: [
                        { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
                    ]
                }
            ]
        },
        {
            key: 'server',
            text: 'Server',
            value: 'Server',
            apiCategory: 'server',
            selectionMode: 'productQuantity',
            apiProductName: 'serverBackup',
            defaultAddonApiKeys: ['sqlBackup'],
            addons: [
                { name: 'SQL Backup', apiKey: 'sqlBackup' },
                { name: 'Backup Network Drives', apiKey: 'backupNetworkDrive' },
                { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
            ]
        },
        {
            key: 'endpoint',
            text: 'Endpoint',
            value: 'Endpoint',
            apiCategory: 'endpoint',
            selectionMode: 'productQuantity',
            apiProductName: 'endpointBackup',
            addons: [
                { name: 'Ransomware Defense Suite (RDS)', apiKey: 'ransomwareDefenseSuite' },
                { name: 'Anti-Malware Scanning', apiKey: 'endpointRestoreAvScan' },
                { name: 'Cloud to Cloud (C2C) Restore', apiKey: 'cloudToCloudRestore' },
                { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
            ]
        },
        {
            key: 'managed_file_transfer',
            text: 'Managed File Transfer (MFT / BluSync)',
            value: 'Managed File Transfer (MFT / BluSync)',
            apiCategory: 'managedFileTransfer',
            selectionMode: 'productQuantity',
            apiProductName: 'mft',
            addons: [
                {
                    name: 'MiniClouds',
                    apiKey: 'miniCloudsPack',
                    hasQuantity: true,
                    quantityField: 'miniCloudsPackQuantity'
                },
                { name: 'Anti-Malware Scanning', apiKey: 'avScanEnabled' },
                { name: 'eDiscovery / Search', apiKey: 'eDiscoverySearch' }
            ]
        }
    ],
    // Values must match the workflow_dispatch choice options in the agent workflows.
    agent_operating_systems: [
        { key: 'windows', text: 'Windows', value: 'Windows' },
        { key: 'linux_debian', text: 'Linux (Debian)', value: 'LinuxDebian' },
        { key: 'linux_rpm', text: 'Linux (RPM)', value: 'LinuxRPM' },
        { key: 'mac', text: 'Mac', value: 'Mac' }
    ],
    agent_backup_types: [
        {
            key: 'servers',
            text: 'Servers',
            value: 'Servers',
            disallowedOperatingSystems: ['Mac']
        },
        { key: 'endpoints', text: 'Endpoints', value: 'Endpoints' }
    ],
    agent_environments: [
        { key: 'prod_use', text: 'PROD_USE (US East)', value: 'PROD_USE' },
        { key: 'prod_in', text: 'PROD_IN (Central India)', value: 'PROD_IN' },
        { key: 'prod_ffm', text: 'PROD_FFM (Germany West Central)', value: 'PROD_FFM' },
        { key: 'prod_uae', text: 'PROD_UAE (UAE North)', value: 'PROD_UAE' },
        { key: 'prod_cac', text: 'PROD_CAC (Canada Central)', value: 'PROD_CAC' },
        { key: 'qa2', text: 'QA2', value: 'QA2' }
    ]
};

export const getDropdownDefaults = (groupKey) => dropdownDefaults[groupKey] || [];
